import { storeConfig } from "../config/store.config";

// Lightweight className combiner (no external deps).
export const cn = (...args) => args.filter(Boolean).join(" ");

// Currency formatting — INR ₹ with Indian digit grouping.
export const formatPrice = (amount) => {
  if (amount == null) return "";
  const formatted = new Intl.NumberFormat(storeConfig.locale, {
    maximumFractionDigits: 0,
  }).format(amount);
  return `${storeConfig.currencySymbol}${formatted}`;
};

// Unique key for a cart line item (product + selected variant).
export const cartLineId = (productId, size, color) =>
  `${productId}::${size || "-"}::${color || "-"}`;

// Discount percentage helper (for SALE badges / compare-at price).
export const discountPercent = (price, compareAt) => {
  if (!compareAt || compareAt <= price) return 0;
  return Math.round(((compareAt - price) / compareAt) * 100);
};
